export default __webpack_public_path__ + "static/media/filter.73ebab7c.svg";